<template>
    <b-modal ref="modal" title="Historial de la Cita" hide-footer id="agenda-appointment-history">
        <div v-if="is_loading" class="mx-4 my-4 text-center">
            <h4>Cargando historial <i class="fa fa-circle-notch fa-spin"></i></h4>
        </div>
        <table v-else class="table">
            <thead>
                <th>
                    FECHA
                </th>
                <th>
                    HORA
                </th>
                <th>
                    USUARIO
                </th>
                <th>
                    ACCIÓN
                </th>
                <th>
                    ESTADO
                </th>
                <th>
                    DATOS
                </th>
            </thead>
            <tbody>
                <appointment-history-entry v-for="entry in appointment_history" :key="entry.id"
                    :entry="entry"></appointment-history-entry>
            </tbody>
        </table>
    </b-modal>
</template>
<script>
export default {
    props: [
        'appointment',
    ],
    data() {
        return {
            is_loading: false,
            appointment_history: [],
        }
    },
    computed: {
        ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
    },
    methods: {
        show() {
            this.is_loading = false;
            this.appointment_history = [];
            this.loadHistory();
            this.$refs.modal.show();
        },
        loadHistory() {
            if (!this.appointment && this.is_loading) return;
            this.is_loading = true;

            const url = `/clinic/${this.clinic.id}/appointments/${this.appointment.id}/history/`;
            axios.get(url).then((response) => {
                this.appointment_history = this.processAppointmentHistory(response.data);
            }).catch((error) => {
                this.msgwindow.error('Error cargando historial de cita');
                console.log('Error loading history', error);
            }).then(() => {
                this.is_loading = false;
            });
        },
        processAppointmentHistory(entries) {
            let ret = [];
            let last_data = WabiDent.cloneObj(this.appointment);

            entries.forEach((entry) => {
                if (!entry.data.id) {
                    last_data.status = entry.data.status;
                    last_data.updated_at = entry.created_at;
                    entry.data = last_data;
                }
                ret.push(entry);
                last_data = WabiDent.cloneObj(entry.data);
            });

            return ret;
        }
    }
}
</script>
<style lang="scss">
#agenda-appointment-history {
    .modal-dialog {
        max-width: 960px !important;
    }
}
</style>